<template>
  <div>
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'article', include: 3, order:'-fields.publishedDate', select: 'fields.title,fields.preview,fields.coverImg,fields.preview,fields.slug,fields.publishedDate,fields.authors,fields.youtubeVideoId' }"
      :key-path="['articles']"
    />
    <loading
      v-if="status==='loading'"
      :rotate="true"
    />
    <div
      v-if="data"
      class="v-content-container">
      <MainArticle
        :data="data"/>
      <Separator/>
      <ArticleList
        :data="data"/>
    </div>
  </div>
</template>

<style scoped >
.v-content-container > * {
  margin-bottom: 2em;
}
</style>

<script>
import { getApiData, getApiStatus } from "vuex-api";
import { mapState } from "vuex";
import MainArticle from "./main-article/index";
import ArticleList from "./article-list/index";
import Separator from "./separator";
import MetisLogo from "../ui/metis-logo";

export default {
  name: "Articles",
  components: { MetisLogo, Separator, ArticleList, MainArticle },
  computed: mapState({
    data: getApiData("articles"),
    status: getApiStatus("articles")
  })
};
</script>
